import api from '@/utils/request'

// 解析首页拆分接口响应
export function extractIndexResponse(res) {
  if (!res || typeof res !== 'object') return null
  if (res.code !== undefined && Number(res.code) !== 1) return null
  const payload = res.data !== undefined ? res.data : res
  if (payload === null || payload === undefined) return null
  return payload
}

export function normalizeIndexPayload(payload, arrayField) {
  if (!payload) return {}
  if (Array.isArray(payload)) {
    return arrayField ? { [arrayField]: payload } : {}
  }
  if (typeof payload === 'object') return payload
  return {}
}

// 格式化日期时间
function formatDateTime(date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

// API接口定义
export const dashboardAPI = {
  // 获取大屏所有数据（真实API）- 支持可扩展参数（非首页仍可使用）
  getScreenData(params = {}) {
    return api.get('/screen/index', { params })
  },

  // 首页概要统计：year_event_total、last_year_event_total、event_total、community_area
  getIndexSummary(params = {}) {
    return api.get('/screen/indexSummary', { params })
  },

  // 首页事件数据：event_by_type、event_by_type_group、event_data
  getIndexEvents(params = {}) {
    return api.get('/screen/indexEvents', { params })
  },

  // 首页缴费数据：fee_data
  getIndexFees(params = {}) {
    return api.get('/screen/indexFees', { params })
  },

  // 首页工单数据：order_data
  getIndexOrders(params = {}) {
    return api.get('/screen/indexOrders', { params })
  },

  // 首页地图数据：community_data、inspection_area_site
  getIndexMap(params = {}) {
    return api.get('/screen/indexMap', { params })
  },

  // 首页审验维保：wb_unit、year_audit、month_audit、surpass_wb、no_finish_order、shiyan_125
  getIndexAudit(params = {}) {
    return api.get('/screen/indexAudit', { params })
  },

  // 首页并行拉取拆分接口并合并为与原 /screen/index 一致的数据结构
  async getIndexScreenData(params = {}) {
    const endpoints = [
      { call: () => this.getIndexSummary(params) },
      { call: () => this.getIndexEvents(params) },
      { call: () => this.getIndexFees(params), arrayField: 'fee_data' },
      { call: () => this.getIndexOrders(params), arrayField: 'order_data' },
      { call: () => this.getIndexMap(params) },
      { call: () => this.getIndexAudit(params) }
    ]

    const results = await Promise.allSettled(endpoints.map((item) => item.call()))
    const merged = {}

    results.forEach((result, index) => {
      if (result.status !== 'fulfilled') {
        console.error(`首页拆分接口请求失败[${index}]:`, result.reason)
        return
      }
      const { arrayField } = endpoints[index]
      Object.assign(merged, normalizeIndexPayload(extractIndexResponse(result.value), arrayField))
    })

    if (Object.keys(merged).length > 0) {
      return merged
    }

    // 拆分接口均无数据时，回退旧接口
    try {
      const fallback = await this.getScreenData(params)
      const payload = extractIndexResponse(fallback)
      if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
        return payload
      }
      return payload || {}
    } catch (error) {
      console.error('首页接口 fallback 失败:', error)
      throw error
    }
  },

  // 获取社区/项目设备信息
  getCommunityInfo(id) {
    return api.get('/screen/community_info', { params: { id } })
  },
  // 日管控报表数据
  getScreenReportThree(params = {}) {
    return api.get('/screen/screen_report_three', { params })
  },
  // 周排查报表数据
  getScreenReportWeek(params = {}) {
    return api.get('/screen/screen_report_week', { params })
  },
  // 月调度报表数据
  getScreenReportMonth(params = {}) {
    return api.get('/screen/screen_report_month', { params })
  },
  // 月调度安全报告提交
  submitMonthSafetyReport(data = {}) {
    return api.post('/screen/submitMonthSafetyReport', data)
  },
  // 获取电梯楼层数据 - 控制电梯开门
  getOpendevice(params = {}) {
    return api.get('/screen/opendevice', { params })
  },
  // 获取维保记录详情
  getRecordInfo(params = {}) {
    return api.get('/screen/recordinfo', { params })
  },
  // 获取事件列表数据
  getEventList(params = {}) {
    return api.get('/screen/eventList', { params })
  },

  // 根据社区名称获取项目列表 - 对接真实接口 /api/screen/community_list
  getProjectListByRegion(params = {}) {
    return api.get('/screen/community_list', { params })
  },
  
  // 对讲请求接口
  voiceIntercom(params = {}) {
    return api.post('/screen/voice', params)
  }
}

export default api